import React from 'react';
import PropTypes from 'prop-types';
import {Image} from '@learningblocks/storybook-components';

import T_CLOSED from "./img/transilluminator-closed.svg"
import T_OPEN from "./img/transilluminator-open.svg"
import T_GEL_CLOSED from "./img/transilluminator-closed-with-gel.svg"
import T_GEL_OPEN from "./img/transilluminator-open-with-gel.svg"
import T_ILLUMINATED_CLOSED from "./img/transilluminator-closed-with-gel-illunminated.svg"

export function TransilluminatorImage(props) {
  const getImage = () => {

    let image = T_CLOSED;

    // Has buffer
    if(props.containsGel){
      if(props.open){
        image = T_GEL_OPEN;
      } else {
        if(props.illuminated){
          image = T_ILLUMINATED_CLOSED;
        } else {
          image = T_GEL_CLOSED;
        }
      }
    } else {
      if(props.open){
        image = T_OPEN;
      } else {
        image = T_CLOSED;
      }
    }

    return image;
  }

  const onClick = (event) => {
    event.stopPropagation();
    props.onSelect(!props.open);
  };

  return (
    <div className='transilluminator__image' onClick={onClick}>
      <Image style={{cursor: 'pointer'}} src={getImage()} alt='transilluminator_image' />
    </div>
  );
}

TransilluminatorImage.propTypes = {
  /**
   * Boolean to set if apparatus is open/closed
   */
  open: PropTypes.bool,

  containsGel: PropTypes.bool,
  illuminated: PropTypes.bool,
  /**
   * function to invoke when Image is clicked
   */
  onSelect: PropTypes.func,
};

TransilluminatorImage.defaultProps = {};
